import { Component, Input } from '@angular/core';
import { WorkflowForm } from 'app/models/WorkflowForm';
import { ReviewHistoryEntryView } from 'app/models/form/ReviewHistoryEntryView';
import { REVIEW_HISTORY_ACTIONS } from 'app/models/form/review-history-action.constants';

@Component({
	selector: 'app-review-comments-approval-history',
	templateUrl: './review-comments-approval-history.component.html',
	styleUrls: ['./review-comments-approval-history.component.css'],
	standalone: false,
})
export class ReviewCommentsApprovalHistoryComponent {
	// The section is, by design, only for Send Back to Address Comments rows.
	// Approve, Skip Approval, and Resubmit actions are NOT written to the
	// Review Comments & Approval History table and never trigger the section.
	private readonly historyTriggerActions = new Set<string>([REVIEW_HISTORY_ACTIONS.SEND_BACK_TO_ADDRESS_COMMENTS]);

	@Input() form: WorkflowForm | null = null;
	/** When true (default), wraps content in card + card-body. Set false when nested inside another card or accordion panel. */
	@Input() wrapInCard = true;
	/** When false, hides the in-body title (e.g. when the parent accordion header shows the title). */
	@Input() showHeading = true;

	get shouldShowHistorySection(): boolean {
		return this.reviewHistoryEntries.some((entry) => this.historyTriggerActions.has(entry?.action));
	}

	get reviewHistoryEntries(): ReviewHistoryEntryView[] {
		return this.form?.reviewHistoryEntries ?? [];
	}

	formatAction(action: string | null | undefined): string {
		switch (action) {
			case REVIEW_HISTORY_ACTIONS.SEND_BACK_TO_ADDRESS_COMMENTS:
				return 'Sent Back To Address Comments';
			default:
				return action || '-';
		}
	}
}
